import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {ApplicationConfig} from '../../../config/application.config';

@Injectable()
export class UserPreferencesService {
  constructor(private localStorageService: LocalStorageService, private applicationConfig: ApplicationConfig) {}

  public getBackgroundUrl(): string {
    return this.applicationConfig.DEFAULT_BACKGROUND_URL;
  }

  public getCompanyLogoUrl(): string {
    return this.applicationConfig.DEFAULT_LOGO_URL;
  }

  public getPrimaryColor(): string {
    return this.applicationConfig.DEFAULT_PRIMARY_COLOR;
  }

  public getPrimaryTextColor(): string {
    return this.applicationConfig.DEFAULT_PRIMARY_TEXT_COLOR;
  }

  public getSecondaryColor(): string {
    return this.applicationConfig.DEFAULT_SECONDARY_COLOR;
  }

  public getSecondaryTextColor(): string {
    return this.applicationConfig.DEFAULT_SECONDARY_TEXT_COLOR;
  }

  public getFont(): string {
    return this.applicationConfig.DEFAULT_FONT;
  }

  public getTextColor(): string {
    return this.applicationConfig.DEFAULT_TEXT_COLOR;
  }

  public getTitleTextColor(): string {
    return this.applicationConfig.DEFAULT_TITLE_TEXT_COLOR;
  }
}
